const STORAGE_KEY = 'login_redirect_to'
const TTL_MS = 600_000

type RedirectEntry = {
  path: string
  timestamp: number
}

function isRedirectEntry(value: unknown): value is RedirectEntry {
  if (typeof value !== 'object' || value === null) return false
  if (!('path' in value) || !('timestamp' in value)) return false
  return typeof value.path === 'string' && typeof value.timestamp === 'number'
}

export const isValidRedirectPath = (path: string): boolean =>
  path.startsWith('/') && !path.startsWith('//')

export const saveLoginRedirectTo = (path: string): void => {
  try {
    if (!isValidRedirectPath(path)) return
    const entry: RedirectEntry = { path, timestamp: Date.now() }
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(entry))
  } catch {
    // sessionStorage unavailable (private mode)
  }
}

export const consumeLoginRedirectTo = (): string => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    sessionStorage.removeItem(STORAGE_KEY)
    if (!raw) return '/'

    const parsed: unknown = JSON.parse(raw)
    if (!isRedirectEntry(parsed)) return '/'
    if (!isValidRedirectPath(parsed.path)) return '/'
    if (Date.now() - parsed.timestamp > TTL_MS) return '/'

    return parsed.path
  } catch {
    return '/'
  }
}
